import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import ghostImg from '../../assets/images/ghostie_noshowings.png'
import { Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const styles = () => ({
  ghostText: {
    padding: '20px 0px 10px 0px',
    transform: 'scale(1.5)'
  },
  ghostImage: {
    transform: 'scale(.4)',
    margin: '-90px'
  }
})

const GhostShowing = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        height: '70vh'
      }}
    >
      <div>
        <Typography variant="h6" style={{ paddingTop: '30px' }}>
          You haven't saved any showings yet
        </Typography>
        <img
          src={ghostImg}
          style={{ transform: 'scale(.5)', margin: '-76px' }}
          alt="ghost"
        />
        <Typography variant="body1">
          Click here to start your <br /> first Safe Showing!
        </Typography>
      </div>
    </div>
  )
}
const mapStateToProps = () => {
  return {}
}
const mapActionsToProps = () => {
  return {}
}

export default compose(
  connect(
    mapStateToProps,
    mapActionsToProps
  ),
  withStyles(styles)
)(GhostShowing)
